import httpService from "./httpService";

const PISubjectApi = {
    
    
    getPISubjectList: (limit, page, searchData, status, editor_id, investigator_id, phase_id, user_id, sort_by, order_by) => 
        httpService.get('newSubjectList', {
            params: {
                limit: limit || 10,
                page: page || 1,
                searchData: searchData || '', // Should be search term, not status array
                status: status || '', // This should contain the status array like [2]
                editor_id: editor_id || '',
                investigator_id: investigator_id || '', 
                phase_id: phase_id || '',
                user_id: user_id || '',
                sort_by: sort_by || '',
                order_by: order_by || ''
            }
        }),
    getPhaseDropDown: (search, investigator_id='',user_id='') => httpService.get('phaseDropDown', {
        params: {
            searchData: search,
            investigator_id,
            user_id
        }
    }),
    subadminDropDown: (investigator_id='',user_id='') => httpService.post(`subadminDropDown/${5}`, {
        "ids": [],
        investigator_id,
        user_id
    }),
    statusDropdown: () => httpService.get('subjectStatusDropDown'),
    updateStatus: (id, status) => httpService.post(`updateSubjectStatus/${id}`, {
        status
    })
}

export default PISubjectApi;